import type {ButtonAppearance} from '@Components/button';
import type {BgRemoverUpsellVariant} from '@Libraries/bg-remover-upsell-experiment.library';

export const BG_REMOVER_UPSELL_PANEL_ID = 'bg-remover-upsell-panel';

export const MODAL_WIDTH_VARIANT_A = '780px';
export const MODAL_WIDTH_VARIANT_B = '862px';

export enum BgRemoverCtaAction {
  VIEW_PLANS = 'view-plans',
  START_TRIAL = 'start-trial',
}

export interface BgRemoverUpsellCta {
  text: string;
  action: BgRemoverCtaAction;
  buttonAppearance: ButtonAppearance;
  showCrownIcon: boolean;
  ga4ClickName: string;
}

export interface BgRemoverUpsellPoint {
  text: string;
  icon: string | null;
}

export interface BgRemoverUpsellGraphic {
  videoUrl: string;
  stillUrl: string;
}

export interface BgRemoverUpsellData {
  eyebrow: string | null;
  header: string;
  points: BgRemoverUpsellPoint[];
  graphic: BgRemoverUpsellGraphic;
  primaryCta: BgRemoverUpsellCta;
  secondaryCta: BgRemoverUpsellCta | null;
}

export interface BgRemoverUpsellPanelProps {
  panelId: string;
  variant: BgRemoverUpsellVariant;
}

export interface BgRemoverUpsellPanelState {
  data: BgRemoverUpsellData | null;
  isLoading: boolean;
  hasFailed: boolean;
}
